import $ from 'jquery';
import OffCanvas from './OffCanvas.mjs';

/**
 * Copy from nm/ui/aside.js
 */
var deviceIsLargeUp = window.matchMedia('only screen and (min-width: 1020px)');

class Aside {
  constructor() {
    this.menuButton = document.getElementById('quicknavigation-menu');
    this.searchButton = document.getElementById('quicknavigation-search');
    this.lastToggle = null;
    this.init();
  }

  init() {
    this.menuButton.addEventListener('click', this.showMenu.bind(this));
    this.searchButton.addEventListener('click', this.showSearch.bind(this));

    var self = this;
    deviceIsLargeUp.addListener(function(mql) {
      if (mql.matches) {
        OffCanvas.hidePanel();
      } else {
        self.hideOffcanvasRight();
      }
    });
  }

  showMenu() {
    if (deviceIsLargeUp.matches === false) {
      OffCanvas.showPanelById('panel-offcanvas-wrapper', this.menuButton);
    }
  }

  showSearch() {
    if (deviceIsLargeUp.matches === false) {
      var panelId = 'panel-search-wrapper';
      OffCanvas.showPanelById(panelId, this.searchButton);
      $('#panel-search-field').each(function(index, field) {
        field.focus();
      });

    } else {
      this.showOffcanvasRight('search', this.searchButton);
    }
  }

  showOffcanvasRight(contentType, toggle) {
    var sidebar = document.getElementById('sidebar-wrapper');
    document.getElementsByTagName('body')[0].classList.add('sidebar-active');
    sidebar.classList.add('active');
    document.getElementById('page-shadow').classList.add('active');

    if (toggle) {
      OffCanvas.setToggleAriaExpanded(toggle, true);
      sidebar.focus();
      this.lastToggle = toggle;
    }
  }

  hideOffcanvasRight() {
    document.getElementsByTagName('body')[0].classList.remove('sidebar-active');
    document.getElementById('page-shadow').classList.remove('active');

    if (Aside.lastToggle) {
      OffCanvas.setToggleAriaExpanded(Aside.lastToggle, false);
      $(Aside.lastToggle).focus();
    }
  }
}

export default (new Aside());
